import { Component, OnInit, ViewChild } from '@angular/core';
import { TreeNode } from 'primeng/primeng';
import { MaterialType } from '../carrier/carrier-enum';
import { Container } from '../container-view/models/container';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { PendingPlatesService } from '../pending-plates/pending-plates.service';
import { ErrorHandler } from "../utils/error-handler";
import { OrderDetails } from './order-details';
import { ReactionPlacementRequest } from './reaction-placement-request';
import { ReactionPlateQuadrant } from './reaction-plate-quadrant';
import { PlateFillingOption, Quadrant } from './reaction-set-enums';
import { ReactionSetService } from './reaction-set.service';
import { StorageResponse } from './storage-response';
import { QuadrantViewComponent } from '../quadrant-view/quadrant-view.component';
import { ReactionSetData, ReactionPlacementRetainPositionRequest } from './reaction-placement-retain-position-request';
import { isNullOrUndefined } from 'util';
import { ReactionPlateState } from '../container-view/models/reaction-plate-state-enum';

interface DNAPlate {
    barcode: string,
    id: string
}
/**
  * @author Naveen
  * @description ReactionSetComponent for Supreme run reaction sets
 */
@Component({
    selector: 'app-reaction-set',
    templateUrl: './reaction-set.component.html',
    styleUrls: ['./reaction-set.component.css']
})
export class ReactionSetComponent implements OnInit {

    @ViewChild(QuadrantViewComponent) quadrantView: QuadrantViewComponent;

    materialType: MaterialType;
    storageResponse: StorageResponse[];
    storageResponseCached: StorageResponse[];
    errorHandler: ErrorHandler = new ErrorHandler;
    dnaPlates: DNAPlate[];
    selectedDnaPlate: DNAPlate;
    selectedValue: string;
    reactionSets: TreeNode[];
    reactionSetsCached: TreeNode[];
    quadrents: TreeNode[];

    selectedNode: TreeNode[];

    isVerticalA1 = false;
    isVerticalB1 = false;
    isVerticalA2 = false;
    isVerticalB2 = false;
    disableTab = true;

    quadrantId: string;
    plateFillingOptions = [{ label: 'Vertical', value: 'VERTICAL' }, { label: 'Horizontal', value: 'HORIZONTAL' }];
    plateFillingOptionSelectionDisabled = false;

    cols: any[];
    primerName: string;
    constructor(private pendingPlatesService: PendingPlatesService, private reactionSetService: ReactionSetService, private messagesService: MessagesService, private masterDataService: MasterDataService) { }

    selectedPlateBarcode: string;


    responseContainers: Container[] = [];
    responseContainer: Container[] = [];

    isCarrier: boolean = false;
    hasToggle: boolean = false;

    pendingPlateId: string;
    index: number = 0;
    pendingReactionPlates: Container[] = [];
    processedReactionPlates: Container[] = [];

    pendingReactionPlate: string;

    products: any[] = [];
    salesItemTypes: any[] = [];
    selectedSIT: any;
    selectedProduct: any;
    loading: boolean;
    blocked: boolean = false;
    selectedRedoOption: string;
    selectedReusedOption: string;

    sampleContainer: string[] = [];
    selectedPriority: string[] = [];
    selectedSampleUsageType: string[] = [];
    defaultReactionOptionProtocolFilter: string[] = []
    selectedReactionOptionProtocol: string[] = []
    selectedLength: string[] = [];
    selectedPrimerType: string[] = [];
    plateState: string;
    positionMap = new Map([["A", 1], ["B", 2], ["C", 3],
    ["D", 4], ["E", 5], ["F", 6],
    ["G", 7], ["H", 8], ["I", 9],
    ["J", 10], ["K", 11], ["L", 12],
    ["M", 13], ["N", 14], ["O", 15],
    ["P", 16]]);

    ngOnInit() {
        this.defaultReactionOptionProtocolFilter = ['Standard']
        this.selectedReactionOptionProtocol = this.defaultReactionOptionProtocolFilter
        this.refreshData(false);
        this.refreshPendingReactionPlates();
        this.refreshProcessedReactionPlates();
        this.getProductsAndSITsFromMDM();
        this.disableTab = true;
        this.selectedRedoOption = "all";
        this.selectedReusedOption = "all";
    }


    getPendingPlate(responseContainers: Container[]) {
        if (responseContainers != null) {
            this.disableTab = false;
            this.responseContainers = this.createEmptyContainers(responseContainers);
        }
    }

    createNewPlate() {
        this.responseContainers = this.createEmptyContainers(this.responseContainer);
    }

    getSelectedPlateBarcode(selectedPlateBarcode: string) {
        this.disableTab = false;
        this.selectedPlateBarcode = selectedPlateBarcode;
        this.quadrantId = 'A1';
        this.index = 1;
    }

    getPendingPlateId(pendingPlateId: string) {
        this.disableTab = false;
        this.pendingPlateId = pendingPlateId;
        this.quadrantId = 'A1'
        this.index = 1;
    }

    placeReactionSets() {
        var features = JSON.parse(localStorage.getItem("features"));
        var toggle = false;
        if (features === null) {
            this.placeReactionsToRetainPositions();
        }
        else {
            features.forEach(item => {
                if (item.featureName === "beta")
                    toggle = item.isActive;
            })

            if (toggle) {
                this.placeReactionsToRetainPositions();
            } else {
                this.placeReactionsOnSelectedQuadrant();
            }
        }
    }

    placeReactionsOnSelectedQuadrant() {
        if (this.selectedNode !== undefined && this.selectedNode !== null && this.selectedNode.length > 0 && this.pendingPlateId !== undefined && this.pendingPlateId !== null) {
            this.blocked = true;
            let reactionIds: Array<string> = new Array<string>();
            let orderHistory: Array<OrderDetails> = new Array<OrderDetails>();
            for (let i = 0; i < this.selectedNode.length; i++) {
                // We only process child nodes. Those have 'children'-property undefined.
                // Using just this criterion is necessary, because it is the only one that is applicable under all scenarios: collapsed root selected, expanded root selected or children selected, but not root
                if (this.selectedNode[i].children === undefined && this.selectedNode[i].data !== undefined && this.selectedNode[i].data !== null && this.selectedNode[i].data.reactionSetId !== undefined && this.selectedNode[i].data.reactionSetId !== null) {
                    reactionIds.push(this.selectedNode[i].data.reactionSetId);
                    let order = new OrderDetails();
                    order.orderId = this.selectedNode[i].data.orderId;
                    order.orderItemId = this.selectedNode[i].data.orderItemId;
                    orderHistory.push(order);
                }
            }

            let rpRequest = new ReactionPlacementRequest();
            rpRequest.reactionPlateId = this.pendingPlateId;
            rpRequest.reactionSetIds = reactionIds;
            rpRequest.reactionPlateQuadrants = this.setQuadrant(this.quadrantId);
            rpRequest.orderHistory = orderHistory;

            this.reactionSetService.placeReactionSetsOnPlate(rpRequest).subscribe(
                result => {
                    if (!result || !result.data || result.data.length == 0) {
                        this.messagesService.addErrorMessage({ severity: 'error', summary: 'NO PLATE DATA RECEIVED', detail: 'No plate data has been returned by backend' });
                        return;
                    }
                    this.responseContainers = this.createEmptyContainers(result.data);
                    this.refreshPendingReactionPlates();
                    this.refreshProcessedReactionPlates();
                    this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Added Carrier', detail: 'Added carrier' });
                    this.blocked = false;
                },
                error => {
                    let message = this.errorHandler.handleError(error);
                    this.messagesService.addErrorMessage(message);
                    this.blocked = false;
                }
            );
        }
        else {
            this.messagesService.addWarningMessage({ severity: 'warn', summary: 'Selection missing', detail: 'Please select a reaction plate and at least one reaction set' });
        }
    }

    /**
     * Place reaction sets on the available positions
     */
    placeReactionsToRetainPositions() {
        if (this.selectedNode !== undefined && this.selectedNode !== null && this.selectedNode.length > 0 && this.pendingPlateId !== undefined && this.pendingPlateId !== null) {
            this.blocked = true;
            let tubeReactionSets: Array<ReactionSetData> = new Array<ReactionSetData>();
            let qcReactionSets: Array<ReactionSetData> = new Array<ReactionSetData>();
            let tubeOrderHistory: Array<OrderDetails> = new Array<OrderDetails>();
            let output: Array<ReactionPlacementRetainPositionRequest> = new Array<ReactionPlacementRetainPositionRequest>();
            let tubeReactionSetIds: Array<string> = new Array<string>();
            let qcReactionSetIds: Array<string> = new Array<string>();
            let tubesampleRefs: Array<string> = new Array<string>();
            let plateSampleRefs: Array<string> = new Array<string>();
            let reactionSetDataMap = new Map();
            let orderHistorymap = new Map();
            let reactionSetIdMap = new Map();
            for (let i = 0; i < this.selectedNode.length; i++) {
                // We only process child nodes. Those have 'children'-property undefined.
                // Using just this criterion is necessary, because it is the only one that is applicable under all scenarios: collapsed root selected, expanded root selected or children selected, but not root
                if (isNullOrUndefined(this.selectedNode[i].children) && this.selectedNode[i].data !== undefined && this.selectedNode[i].data !== null && this.selectedNode[i].data.reactionSetId !== undefined && this.selectedNode[i].data.reactionSetId !== null) {
                    let uniqueBatchKeyToFormRunLevelBatches: string = "";
                    if (this.selectedNode[i].data.sampleQuadrant) {
                        if (this.selectedNode[i].data.salesItemType === "SRPMulti") {
                            uniqueBatchKeyToFormRunLevelBatches = this.selectedNode[i].data.dnaPlateBarcode + "_" + this.selectedNode[i].data.sampleQuadrant + "_" + this.selectedNode[i].data.runLevel;
                        } else {
                            uniqueBatchKeyToFormRunLevelBatches = this.selectedNode[i].data.dnaPlateBarcode + "_" + this.selectedNode[i].data.sampleQuadrant + "_" + this.selectedNode[i].data.runLevel + "_" +
                                this.selectedNode[i].data.primerID;
                        }
                    } else {
                        if (this.selectedNode[i].data.salesItemType === "SRPMulti") {
                            uniqueBatchKeyToFormRunLevelBatches = this.selectedNode[i].data.dnaPlateBarcode + "_" + this.selectedNode[i].data.runLevel;
                        } else {
                            uniqueBatchKeyToFormRunLevelBatches = this.selectedNode[i].data.dnaPlateBarcode + "_" + this.selectedNode[i].data.runLevel + "_" +
                                this.selectedNode[i].data.primerID;
                        }
                    }
                    let reactionSetData: ReactionSetData = this.generateReactionSetData(this.selectedNode[i]);
                    if (this.selectedNode[i].data.salesItemType === "SupremeRun" || this.selectedNode[i].data.salesItemType === "TubeSeq") {
                        tubeReactionSets.push(reactionSetData);
                        tubesampleRefs.push(this.selectedNode[i].data.sampleRef);
                        let order = new OrderDetails();
                        order.orderId = this.selectedNode[i].data.orderId;
                        order.orderItemId = this.selectedNode[i].data.orderItemId;
                        tubeOrderHistory.push(order);
                        tubeReactionSetIds.push(this.selectedNode[i].data.reactionSetId);
                    } else if (this.selectedNode[i].data.materialType === "QCSample") {
                        qcReactionSets.push(reactionSetData);
                        qcReactionSetIds.push(this.selectedNode[i].data.reactionSetId);
                    } else {
                        let reactionSetdataArray: Array<ReactionSetData> = reactionSetDataMap.get(uniqueBatchKeyToFormRunLevelBatches);
                        if (isNullOrUndefined(reactionSetdataArray)) {
                            reactionSetdataArray = new Array<ReactionSetData>();
                        }

                        reactionSetdataArray.push(reactionSetData);
                        reactionSetDataMap.set(uniqueBatchKeyToFormRunLevelBatches, reactionSetdataArray);

                        let orderHistory: Array<OrderDetails> = orderHistorymap.get(uniqueBatchKeyToFormRunLevelBatches);
                        if (isNullOrUndefined(orderHistory)) {
                            orderHistory = new Array<OrderDetails>();
                        }
                        let order = new OrderDetails();
                        order.orderId = this.selectedNode[i].data.orderId;
                        order.orderItemId = this.selectedNode[i].data.orderItemId;
                        orderHistory.push(order);
                        orderHistorymap.set(uniqueBatchKeyToFormRunLevelBatches, orderHistory);

                        let reactionSetIdVal: Array<string> = reactionSetIdMap.get(uniqueBatchKeyToFormRunLevelBatches);
                        if (isNullOrUndefined(reactionSetIdVal)) {
                            reactionSetIdVal = new Array<string>();
                        }
                        reactionSetIdVal.push(this.selectedNode[i].data.reactionSetId);
                        plateSampleRefs.push(this.selectedNode[i].data.sampleRef)
                        reactionSetIdMap.set(uniqueBatchKeyToFormRunLevelBatches, reactionSetIdVal);
                    }

                }
            }

            for (let runLevelBatches of Array.from(reactionSetDataMap.keys())) {
                let runLevelBatch: Array<ReactionSetData> = reactionSetDataMap.get(runLevelBatches);
                let rpRequest = new ReactionPlacementRetainPositionRequest();
                rpRequest.reactionPlateId = this.pendingPlateId;
                rpRequest.reactionSetData = runLevelBatch;
                rpRequest.reactionPlateQuadrants = this.setQuadrant(this.quadrantId);
                rpRequest.orderHistory = orderHistorymap.get(runLevelBatches);
                rpRequest.reactionSetIds = reactionSetIdMap.get(runLevelBatches);
                rpRequest.productType = "SRPlate";
                rpRequest.sampleRefs = plateSampleRefs;
                rpRequest.quadrantId = this.quadrantId;
                output.push(rpRequest);
            }

            if (qcReactionSets.length > 0) {
                let rpRequest = new ReactionPlacementRetainPositionRequest();
                rpRequest.reactionPlateId = this.pendingPlateId;
                rpRequest.reactionSetData = qcReactionSets;
                rpRequest.reactionSetIds = qcReactionSetIds;
                rpRequest.productType = "QCSample";
                rpRequest.quadrantId = this.quadrantId;
                output.push(rpRequest);
            }

            if (tubeReactionSets.length > 0) {
                let rpRequest = new ReactionPlacementRetainPositionRequest();
                rpRequest.reactionPlateId = this.pendingPlateId;
                rpRequest.reactionSetData = tubeReactionSets;
                rpRequest.reactionPlateQuadrants = this.setQuadrant(this.quadrantId);
                rpRequest.orderHistory = tubeOrderHistory;
                rpRequest.reactionSetIds = tubeReactionSetIds;
                rpRequest.productType = "SRTube";
                rpRequest.quadrantId = this.quadrantId;
                rpRequest.sampleRefs = tubesampleRefs;
                output.push(rpRequest);
            }

            this.reactionSetService.placeReactionSetsToRetainPositions(output).subscribe(
                result => {
                    if (!result || !result.data || result.data.length == 0) {
                        this.messagesService.addErrorMessage({ severity: 'error', summary: 'NO PLATE DATA RECEIVED', detail: 'No plate data has been returned by backend' });
                        return;
                    }
                    this.responseContainers = this.createEmptyContainers(result.data);
                    this.refreshPendingReactionPlates();
                    this.refreshProcessedReactionPlates();
                    this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Added Carrier', detail: 'Added carrier' });
                    this.blocked = false;
                },
                error => {
                    let message = this.errorHandler.handleError(error);
                    this.messagesService.addErrorMessage(message);
                    this.blocked = false;
                }
            );
        }
        else {
            this.messagesService.addWarningMessage({ severity: 'warn', summary: 'Selection missing', detail: 'Please select a reaction plate and at least one reaction set' });
        }
    }

    /**
     *
     * @param selectedTreeNode Function that generates reactionset data
     */
    generateReactionSetData(selectedTreeNode: TreeNode) {
        let reactionSetData: ReactionSetData = new ReactionSetData();
        reactionSetData.reactionSetId = selectedTreeNode.data.reactionSetId;
        reactionSetData.reactionSetQuadrant = selectedTreeNode.data.sampleQuadrant;
        reactionSetData.reactionSetBarcode = selectedTreeNode.data.dnaPlateBarcode;
        reactionSetData.reactionSetPosition = selectedTreeNode.data.samplePosition;
        reactionSetData.reactionSetRunLevel = selectedTreeNode.data.runLevel;
        reactionSetData.reactionSetSalesItemType = selectedTreeNode.data.salesItemType;
        reactionSetData.reactionSetSampleBarcode = selectedTreeNode.data.sampleBarcode;
        reactionSetData.reactionSetSampleName = selectedTreeNode.data.sampleName;
        reactionSetData.reactionSetPrimerName = selectedTreeNode.data.primerName;
        reactionSetData.reactionSetSampleRef = selectedTreeNode.data.sampleRef;
        reactionSetData.reactionSetPlaced = false;
        let rowPosition: string = reactionSetData.reactionSetPosition.charAt(0);
        let row = this.positionMap.get(rowPosition);
        reactionSetData.reactionSetRow = row;
        let actualRow = Math.ceil(row / 2);
        reactionSetData.reactionSetActualRow = actualRow;
        let colPosition: any = reactionSetData.reactionSetPosition.substring(1, reactionSetData.reactionSetPosition.length);
        reactionSetData.reactionSetColumn = colPosition;
        let actualCol = Math.ceil(colPosition / 2);
        reactionSetData.reactionSetActualColumn = actualCol;
        reactionSetData.reactionSetOtherQuadrantPosition = actualRow + "," + actualCol;
        return reactionSetData;
    }


    /**
   * @function
   * @description: Creates empty conatiner if it does not have filled quadrant. This is used for bining purpose
   */
    createEmptyContainers(responseContainers: Container[]) {
        let conatiners: Array<Container> = []
        conatiners.push(new Container());
        conatiners.push(new Container());
        conatiners.push(new Container());
        conatiners.push(new Container());
        responseContainers.forEach(element => {
            if (element.barcode.endsWith("B2")) {
                conatiners.splice(3, 1, element)
            }
            if (element.barcode.endsWith("A2")) {
                conatiners.splice(1, 1, element)
            }
            if (element.barcode.endsWith("B1")) {
                conatiners.splice(2, 1, element)
            }
            if (element.barcode.endsWith("A1")) {
                conatiners.splice(0, 1, element)
            }
        })
        return conatiners;
    }

    /**
   * @function
   * @description: Sets quadrant for recation plate
   */
    setQuadrant(quadrantId: string) {
        let reactionPlateQuadrants: Array<ReactionPlateQuadrant> = [];

        switch (quadrantId) {
            case Quadrant.A1: {
                let quadrantA1 = new ReactionPlateQuadrant();
                quadrantA1.quadrant = Quadrant.A1;
                this.isVerticalA1 ? quadrantA1.fillingOption = PlateFillingOption.VERTICAL : quadrantA1.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantA1)

                let quadrantB1 = new ReactionPlateQuadrant();
                quadrantB1.quadrant = Quadrant.B1;
                this.isVerticalB1 ? quadrantB1.fillingOption = PlateFillingOption.VERTICAL : quadrantB1.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantB1);

                let quadrantA2 = new ReactionPlateQuadrant();
                quadrantA2.quadrant = Quadrant.A2;
                this.isVerticalA2 ? quadrantA2.fillingOption = PlateFillingOption.VERTICAL : quadrantA2.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantA2);

                let quadrantB2 = new ReactionPlateQuadrant();
                quadrantB2.quadrant = Quadrant.B2;
                this.isVerticalB2 ? quadrantB2.fillingOption = PlateFillingOption.VERTICAL : quadrantB2.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantB2);

                break;
            }

            case Quadrant.B1: {

                let quadrantB1 = new ReactionPlateQuadrant();
                quadrantB1.quadrant = Quadrant.B1;
                this.isVerticalB1 ? quadrantB1.fillingOption = PlateFillingOption.VERTICAL : quadrantB1.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantB1)

                let quadrantA2 = new ReactionPlateQuadrant();
                quadrantA2.quadrant = Quadrant.A2;
                this.isVerticalA2 ? quadrantA2.fillingOption = PlateFillingOption.VERTICAL : quadrantA2.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantA2)

                let quadrantB2 = new ReactionPlateQuadrant();
                quadrantB2.quadrant = Quadrant.B2;
                this.isVerticalB2 ? quadrantB2.fillingOption = PlateFillingOption.VERTICAL : quadrantB2.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantB2);

                break;
            }

            case Quadrant.A2: {

                let quadrantA2 = new ReactionPlateQuadrant();
                quadrantA2.quadrant = Quadrant.A2;
                this.isVerticalA2 ? quadrantA2.fillingOption = PlateFillingOption.VERTICAL : quadrantA2.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantA2)

                let quadrantB2 = new ReactionPlateQuadrant();
                quadrantB2.quadrant = Quadrant.B2;
                this.isVerticalB2 ? quadrantB2.fillingOption = PlateFillingOption.VERTICAL : quadrantB2.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantB2);

                break;
            }

            case Quadrant.B2: {
                let quadrantB2 = new ReactionPlateQuadrant();
                quadrantB2.quadrant = Quadrant.B2;
                this.isVerticalB2 ? quadrantB2.fillingOption = PlateFillingOption.VERTICAL : quadrantB2.fillingOption = PlateFillingOption.HORIZONTAL;
                reactionPlateQuadrants.push(quadrantB2);
                break;
            }
        }
        return reactionPlateQuadrants;
    }


    /**
   * @function
   * @description: Quadrant change event handler
   */
    onQuadrantIdChange(event) {
        this.quadrantId = event;
    }

    /**
   * @function
   * @description: Axis change handler for A1
   */
    onAxisChangeA1(event) {
        this.isVerticalA1 = event;
    }

    /**
   * @function
   * @description: Axis change handler for B1
   */
    onAxisChangeB1(event) {
        this.isVerticalB1 = event;
    }

    /**
   * @function
   * @description: Axis change handler for A2
   */
    onAxisChangeA2(event) {
        this.isVerticalA2 = event;
    }

    /**
   * @function
   * @description: Axis change handler for B2
   */
    onAxisChangeB2(event) {
        this.isVerticalB2 = event;
    }


    changeTab(event) {
        console.log("Change tab event")
        this.index = event;
        if (event == 0) {
            this.disableTab = true;
        }
        this.refreshPendingReactionPlates();
        this.refreshProcessedReactionPlates();
        this.refreshData(false);
    }


    /**
      * @function
      * @description on click of dna plate radio button
     */
    onClickDNA() {

        this.selectedDnaPlate = null;
        this.storageResponse = this.storageResponseCached
        let storageResponseTemp: StorageResponse[] = [];
        this.reactionSets = [];
        this.storageResponse.forEach(plate => {

            if (plate.materialType == "Sample") {
                storageResponseTemp.push(plate)

                let quadNodes: TreeNode[] = [];

                if (plate.quadrantResponseList.length > 0) {

                    plate.quadrantResponseList.forEach(quadResponse => {

                        let runLevelNodesForDNAFilter: TreeNode[] = []
                        if (quadResponse.levelItems.length > 0) {

                            quadResponse.levelItems.forEach(levelResponse => {

                                let reactionNodes: TreeNode[] = [];
                                if (levelResponse.reactionSetResponseList.length > 0) {

                                    levelResponse.reactionSetResponseList.forEach(reaction => {
                                        reactionNodes.push({
                                            data: reaction
                                        })
                                    })
                                }

                                runLevelNodesForDNAFilter.push({
                                    data: levelResponse,
                                    children: reactionNodes
                                })
                            })
                        }

                        quadNodes.push({
                            data: quadResponse,
                            children: runLevelNodesForDNAFilter
                        })

                    })

                    this.reactionSets.push({
                        data: plate,
                        children: quadNodes
                    })
                }


                let runLevelNodes: TreeNode[] = []
                if (plate.runLevelResponseList.length > 0) {

                    plate.runLevelResponseList.forEach(levelResponse => {

                        let reactionNodes: TreeNode[] = []
                        if (levelResponse.reactionSetResponseList.length > 0) {

                            levelResponse.reactionSetResponseList.forEach(reaction => {
                                reactionNodes.push({
                                    data: reaction
                                })
                            })
                        }

                        runLevelNodes.push({
                            data: levelResponse,
                            children: reactionNodes
                        })

                    });

                    this.reactionSets.push({
                        data: plate,
                        children: runLevelNodes
                    })

                }
            }
        })
        this.storageResponse = storageResponseTemp;
        this.resetDefaults();
        if (this.index == 0) {
            this.disableTab = true;
        }
    }

    /**
    * @function
    * @description on click of primer radio button
    */
    onClickPrimer() {
        this.selectedDnaPlate = null;
        this.storageResponse = this.storageResponseCached
        let storageResponseTemp: StorageResponse[] = [];
        this.reactionSets = [];
        this.storageResponse.forEach(plate => {
            if (plate.materialType == "Primer") {
                storageResponseTemp.push(plate)
                let quadNodes: TreeNode[] = [];

                if (plate.quadrantResponseList.length > 0) {

                    plate.quadrantResponseList.forEach(quadResponse => {

                        let runLevelNodesForPrimerFilter: TreeNode[] = []
                        if (quadResponse.levelItems.length > 0) {

                            quadResponse.levelItems.forEach(levelResponse => {

                                let reactionNodes: TreeNode[] = [];
                                if (levelResponse.reactionSetResponseList.length > 0) {

                                    levelResponse.reactionSetResponseList.forEach(reaction => {
                                        reactionNodes.push({
                                            data: reaction
                                        })
                                    })
                                }

                                runLevelNodesForPrimerFilter.push({
                                    data: levelResponse,
                                    children: reactionNodes
                                })
                            })
                        }

                        quadNodes.push({
                            data: quadResponse,
                            children: runLevelNodesForPrimerFilter
                        })

                    })

                    this.reactionSets.push({
                        data: plate,
                        children: quadNodes
                    })
                }


                let runLevelNodes: TreeNode[] = []
                if (plate.runLevelResponseList.length > 0) {

                    plate.runLevelResponseList.forEach(levelResponse => {

                        let reactionNodes: TreeNode[] = []
                        if (levelResponse.reactionSetResponseList.length > 0) {

                            levelResponse.reactionSetResponseList.forEach(reaction => {
                                reactionNodes.push({
                                    data: reaction
                                })
                            })
                        }

                        runLevelNodes.push({
                            data: levelResponse,
                            children: reactionNodes
                        })

                    });

                    this.reactionSets.push({
                        data: plate,
                        children: runLevelNodes
                    })

                }
            }
        })
        this.storageResponse = storageResponseTemp;
        this.resetDefaults();
    }
    /**
    * @function
    * @description on click to resett all
    */
    onClickAll() {
        this.selectedDnaPlate = null;
        this.storageResponse = this.storageResponseCached;
        let storageResponseTemp: StorageResponse[] = [];
        this.reactionSets = [];
        this.storageResponse.forEach(plate => {

            storageResponseTemp.push(plate)
            let quadNodes: TreeNode[] = [];

            if (plate.quadrantResponseList.length > 0) {

                plate.quadrantResponseList.forEach(quadResponse => {

                    let runLevelNodesForNoFilter: TreeNode[] = []
                    if (quadResponse.levelItems.length > 0) {

                        quadResponse.levelItems.forEach(levelResponse => {

                            let reactionNodes: TreeNode[] = [];
                            if (levelResponse.reactionSetResponseList.length > 0) {

                                levelResponse.reactionSetResponseList.forEach(reaction => {
                                    reactionNodes.push({
                                        data: reaction
                                    })
                                })
                            }

                            runLevelNodesForNoFilter.push({
                                data: levelResponse,
                                children: reactionNodes
                            })
                        })
                    }

                    quadNodes.push({
                        data: quadResponse,
                        children: runLevelNodesForNoFilter
                    })

                })

                this.reactionSets.push({
                    data: plate,
                    children: quadNodes
                })
            }


            let runLevelNodes: TreeNode[] = []
            if (plate.runLevelResponseList.length > 0) {

                plate.runLevelResponseList.forEach(levelResponse => {

                    let reactionNodes: TreeNode[] = []
                    if (levelResponse.reactionSetResponseList.length > 0) {

                        levelResponse.reactionSetResponseList.forEach(reaction => {
                            reactionNodes.push({
                                data: reaction
                            })
                        })
                    }

                    runLevelNodes.push({
                        data: levelResponse,
                        children: reactionNodes
                    })

                });

                this.reactionSets.push({
                    data: plate,
                    children: runLevelNodes
                })

            }
        })
        this.storageResponse = storageResponseTemp;
        this.resetDefaults();
    }

    /**
    * @function
    * @description filtering on dropdown selction
    */
    dropdownChange() {

        this.storageResponse = this.storageResponseCached
        let storageResponseTemp: StorageResponse[] = [];
        this.reactionSets = [];

        if (this.selectedDnaPlate) {

            this.selectedValue = 'dna';
            this.storageResponse.forEach(plate => {

                storageResponseTemp.push(plate)
                if (plate.conatinerBarcode == this.selectedDnaPlate.barcode) {

                    let quadNodes: TreeNode[] = [];

                    if (plate.quadrantResponseList.length > 0) {

                        plate.quadrantResponseList.forEach(quadResponse => {

                            let runLevelNodesOnDropDownChange: TreeNode[] = []
                            if (quadResponse.levelItems.length > 0) {

                                quadResponse.levelItems.forEach(levelResponse => {

                                    let reactionNodes: TreeNode[] = [];
                                    if (levelResponse.reactionSetResponseList.length > 0) {

                                        levelResponse.reactionSetResponseList.forEach(reaction => {
                                            reactionNodes.push({
                                                data: reaction
                                            })
                                        })
                                    }

                                    runLevelNodesOnDropDownChange.push({
                                        data: levelResponse,
                                        children: reactionNodes
                                    })
                                })
                            }

                            quadNodes.push({
                                data: quadResponse,
                                children: runLevelNodesOnDropDownChange
                            })

                        })

                        this.reactionSets.push({
                            data: plate,
                            children: quadNodes
                        })
                    }


                    let runLevelNodes: TreeNode[] = []
                    if (plate.runLevelResponseList.length > 0) {

                        plate.runLevelResponseList.forEach(levelResponse => {

                            let reactionNodes: TreeNode[] = []
                            if (levelResponse.reactionSetResponseList.length > 0) {

                                levelResponse.reactionSetResponseList.forEach(reaction => {
                                    reactionNodes.push({
                                        data: reaction
                                    })
                                })
                            }

                            runLevelNodes.push({
                                data: levelResponse,
                                children: reactionNodes
                            })

                        });

                        this.reactionSets.push({
                            data: plate,
                            children: runLevelNodes
                        })

                    }

                }
            })
        } else {

            this.selectedValue = 'all';
            this.storageResponse.forEach(plate => {
                storageResponseTemp.push(plate)
                let quadNodes: TreeNode[] = [];

                if (plate.quadrantResponseList.length > 0) {

                    plate.quadrantResponseList.forEach(quadResponse => {

                        let runLevelNodesWithoutFilter: TreeNode[] = []
                        if (quadResponse.levelItems.length > 0) {

                            quadResponse.levelItems.forEach(levelResponse => {

                                let reactionNodes: TreeNode[] = [];
                                if (levelResponse.reactionSetResponseList.length > 0) {

                                    levelResponse.reactionSetResponseList.forEach(reaction => {
                                        reactionNodes.push({
                                            data: reaction
                                        })
                                    })
                                }

                                runLevelNodesWithoutFilter.push({
                                    data: levelResponse,
                                    children: reactionNodes
                                })
                            })
                        }

                        quadNodes.push({
                            data: quadResponse,
                            children: runLevelNodesWithoutFilter
                        })

                    })

                    this.reactionSets.push({
                        data: plate,
                        children: quadNodes
                    })
                }


                let runLevelNodes: TreeNode[] = []
                if (plate.runLevelResponseList.length > 0) {

                    plate.runLevelResponseList.forEach(levelResponse => {

                        let reactionNodes: TreeNode[] = []
                        if (levelResponse.reactionSetResponseList.length > 0) {

                            levelResponse.reactionSetResponseList.forEach(reaction => {
                                reactionNodes.push({
                                    data: reaction
                                })
                            })
                        }

                        runLevelNodes.push({
                            data: levelResponse,
                            children: reactionNodes
                        })

                    });

                    this.reactionSets.push({
                        data: plate,
                        children: runLevelNodes
                    })

                }
            })
        }

        this.storageResponse = storageResponseTemp;
        this.selectedProduct = null;
        this.selectedSIT = null;
        this.resetDefaults();
    }

    /**
    * @function
    * @description data refrsh from backend
    */
    refreshData(clearFilterFlag: boolean) {

        this.loading = true;
        this.selectedDnaPlate = null;
        //this.selectedValue = 'all';
        this.primerName = "";
        this.selectedPriority = [];
        this.sampleContainer = [];
        this.selectedPriority = [];
        this.selectedSampleUsageType = [];
        this.selectedReactionOptionProtocol = [];
        this.selectedLength = [];
        this.selectedPrimerType = [];
        if (clearFilterFlag === false) {
            this.selectedReactionOptionProtocol = this.defaultReactionOptionProtocolFilter;
        }
        let lab = JSON.parse(localStorage.getItem("lab"));

        this.reactionSetService.fetchReactionSetsWithFilter("", [], [], [], this.selectedReactionOptionProtocol, [], lab.lab._id).subscribe(
            results => {

                if (!results) {
                    return;
                }

                if (results.data) {
                    //console.log("Reaction sets:", results.data);
                    this.storageResponse = results.data;
                    this.storageResponseCached = results.data;
                    this.reactionSets = [];
                    this.quadrents = [];
                    this.selectedNode = null;
                    this.dnaPlates = [];
                    this.storageResponse.forEach(plate => {

                        if (plate.materialType == "Sample") {
                            this.dnaPlates.push({ barcode: plate.conatinerBarcode, id: plate.conatinerId })
                            //console.log(this.dnaPlates);
                        }

                        let quadNodes: TreeNode[] = [];

                        if (plate.quadrantResponseList.length > 0) {

                            plate.quadrantResponseList.forEach(quadResponse => {

                                let runLevelNodesAfterFilter: TreeNode[] = []
                                if (quadResponse.levelItems.length > 0) {

                                    quadResponse.levelItems.forEach(levelResponse => {

                                        let reactionNodes: TreeNode[] = [];
                                        if (levelResponse.reactionSetResponseList.length > 0) {

                                            levelResponse.reactionSetResponseList.forEach(reaction => {
                                                reactionNodes.push({
                                                    data: reaction
                                                })
                                            })
                                        }
                                        if (reactionNodes.length > 0)
                                            runLevelNodesAfterFilter.push({
                                                data: levelResponse,
                                                children: reactionNodes
                                            })
                                    })
                                }

                                quadNodes.push({
                                    data: quadResponse,
                                    children: runLevelNodesAfterFilter
                                })

                            })

                            this.reactionSets.push({
                                data: plate,
                                children: quadNodes
                            })
                        }


                        let runLevelNodes: TreeNode[] = []
                        if (plate.runLevelResponseList.length > 0) {

                            plate.runLevelResponseList.forEach(levelResponse => {

                                let reactionNodes: TreeNode[] = []
                                if (levelResponse.reactionSetResponseList.length > 0) {

                                    levelResponse.reactionSetResponseList.forEach(reaction => {
                                        reactionNodes.push({
                                            data: reaction
                                        })
                                    })
                                }
                                if (reactionNodes.length > 0)
                                    runLevelNodes.push({
                                        data: levelResponse,
                                        children: reactionNodes
                                    })

                            });

                            this.reactionSets.push({
                                data: plate,
                                children: runLevelNodes
                            })
                        }
                    })
                }
                this.loading = false
                this.resetDefaults();
            },
            error => {
                let message = this.errorHandler.handleError(error);
                this.messagesService.addErrorMessage(message);
                this.loading = false
            }
        )
    }


    /**
   * @function
   * @description: Refreshes pending reaction sets
   */
    refreshPendingReactionPlates() {
        this.pendingPlatesService.getPendingReactionPlates(ReactionPlateState.WORK_IN_PROGRESS).subscribe(
            results => {
                if (!results) {
                    return;
                }
                this.pendingReactionPlates = results.data;
            },
            error => {
                let message = this.errorHandler.handleError(error);
                this.messagesService.addErrorMessage(message);
            }
        );
    }

    /**
* @function
* @description: Refreshes processed reaction sets
*/
    refreshProcessedReactionPlates() {
        this.pendingPlatesService.getPendingReactionPlates(ReactionPlateState.REACTIONS_PLACED).subscribe(
            results => {
                if (!results) {
                    return;
                }
                this.processedReactionPlates = results.data;
            },
            error => {
                let message;
                if (error.error.bbApiError.message === 'The Reaction Plate not found in BB Database.') {
                    message = {
                        severity: 'warn', summary: 'Reaction Plates not found',
                        detail: 'There are no reaction plates in state REACTIONS_PALCED in the last 24 hours'
                    };
                    this.messagesService.addWarningMessage(message);
                } else {
                    message = this.errorHandler.handleError(error);
                    this.messagesService.addErrorMessage(message);
                }
            }
        );
    }

    /**
   * @function
   * @description: Tab change event handler for Reaction screen
   */
    onTabChange(event) {
        switch (event.index) {
            case 0:
                {
                    this.refreshPendingReactionPlates();
                    this.refreshProcessedReactionPlates();
                    this.index = 0;
                    this.quadrantId = 'A1';
                    break;
                }
            case 1:
                {
                    this.index = 1;
                    break;
                }
        }
    }

    /**
     * @function
     * @description Filter the Reaction Sets based on Selected product
     */
    onProductSelect() {
        this.storageResponse = this.storageResponseCached;
        this.reactionSets = [];
        if (this.selectedProduct == "All Reactions" || !this.selectedProduct)
            this.onClickAll();
        else {
            let storageResponseTemp: StorageResponse[] = [];
            this.reactionSets = [];
            this.storageResponse.forEach(plate => {

                let quadNodes: TreeNode[] = [];

                if (plate.quadrantResponseList.length > 0) {

                    plate.quadrantResponseList.forEach(quadResponse => {

                        let runLevelNodesOnProductSelect: TreeNode[] = []
                        if (quadResponse.levelItems.length > 0) {

                            quadResponse.levelItems.forEach(levelResponse => {

                                let reactionNodes: TreeNode[] = [];
                                if (levelResponse.reactionSetResponseList.length > 0) {

                                    levelResponse.reactionSetResponseList.forEach(reaction => {
                                        if (reaction.sampleName == "Eurofins_QC" || (reaction.productName != null && reaction.productName == this.selectedProduct)) {
                                            reactionNodes.push({
                                                data: reaction
                                            })
                                        }
                                    })
                                }
                                if (reactionNodes.length > 0)
                                    runLevelNodesOnProductSelect.push({
                                        data: levelResponse,
                                        children: reactionNodes
                                    })
                            })
                        }
                        if (runLevelNodesOnProductSelect.length > 0)
                            quadNodes.push({
                                data: quadResponse,
                                children: runLevelNodesOnProductSelect
                            })

                    })
                    if (quadNodes.length > 0) {
                        this.reactionSets.push({
                            data: plate,
                            children: quadNodes
                        })
                    }
                }


                let runLevelNodes: TreeNode[] = []
                if (plate.runLevelResponseList.length > 0) {

                    plate.runLevelResponseList.forEach(levelResponse => {

                        let reactionNodes: TreeNode[] = []
                        if (levelResponse.reactionSetResponseList.length > 0) {

                            levelResponse.reactionSetResponseList.forEach(reaction => {
                                if (reaction.sampleName == "Eurofins_QC" || (reaction.productName != null && reaction.productName == this.selectedProduct)) {
                                    reactionNodes.push({
                                        data: reaction
                                    })
                                }
                            })
                        }

                        if (reactionNodes.length > 0)
                            runLevelNodes.push({
                                data: levelResponse,
                                children: reactionNodes
                            })

                    });
                    if (runLevelNodes.length > 0) {
                        this.reactionSets.push({
                            data: plate,
                            children: runLevelNodes
                        })
                    }

                }
            })
            this.storageResponse = storageResponseTemp;
            this.selectedDnaPlate = null;
            this.selectedSIT = null;
            this.resetDefaults();
        }
    }

    /**
     * @function
     * @description Filter the Reaction Sets based on Selected SIT
     */
    onSITSelect() {
        this.storageResponse = this.storageResponseCached;
        this.reactionSets = [];
        if (this.selectedSIT == "All Reactions" || !this.selectedSIT)
            this.onClickAll();
        else {
            let storageResponseTemp: StorageResponse[] = [];
            this.reactionSets = [];
            this.storageResponse.forEach(plate => {
                let quadNodes: TreeNode[] = [];

                if (plate.quadrantResponseList.length > 0) {

                    plate.quadrantResponseList.forEach(quadResponse => {

                        let runLevelNodesOnSITSelect: TreeNode[] = []
                        if (quadResponse.levelItems.length > 0) {

                            quadResponse.levelItems.forEach(levelResponse => {

                                let reactionNodes: TreeNode[] = [];
                                if (levelResponse.reactionSetResponseList.length > 0) {

                                    levelResponse.reactionSetResponseList.forEach(reaction => {

                                        if (reaction.sampleName == "Eurofins_QC" || (reaction.salesItemType != null && reaction.salesItemType == this.selectedSIT)) {
                                            reactionNodes.push({
                                                data: reaction
                                            })
                                        }
                                    })
                                }

                                if (reactionNodes.length > 0)
                                    runLevelNodesOnSITSelect.push({
                                        data: levelResponse,
                                        children: reactionNodes
                                    })
                            })
                        }
                        if (runLevelNodesOnSITSelect.length > 0)
                            quadNodes.push({
                                data: quadResponse,
                                children: runLevelNodesOnSITSelect
                            })

                    })
                    if (quadNodes.length > 0) {
                        this.reactionSets.push({
                            data: plate,
                            children: quadNodes
                        })
                    }
                }


                let runLevelNodes: TreeNode[] = []
                if (plate.runLevelResponseList.length > 0) {

                    plate.runLevelResponseList.forEach(levelResponse => {

                        let reactionNodes: TreeNode[] = []
                        if (levelResponse.reactionSetResponseList.length > 0) {

                            levelResponse.reactionSetResponseList.forEach(reaction => {
                                if (reaction.sampleName == "Eurofins_QC" || (reaction.salesItemType != null && reaction.salesItemType == this.selectedSIT)) {
                                    reactionNodes.push({
                                        data: reaction
                                    })
                                }
                            })
                        }

                        if (reactionNodes.length > 0)
                            runLevelNodes.push({
                                data: levelResponse,
                                children: reactionNodes
                            })

                    });
                    if (runLevelNodes.length > 0) {
                        this.reactionSets.push({
                            data: plate,
                            children: runLevelNodes
                        })
                    }

                }

            })
            this.storageResponse = storageResponseTemp;
            this.selectedDnaPlate = null;
            this.selectedProduct = null;
            this.resetDefaults();
        }
    }

    //Get Products and SITs From MDM and Display in the Dropdowns
    getProductsAndSITsFromMDM() {
        let lab = JSON.parse(localStorage.getItem("lab"));
        this.masterDataService.getProductsByLab(lab.lab._id, true).subscribe(
            results => {
                if (!results) {
                    return;
                }
                results.data.forEach(element => {
                    this.products.push({ label: element.name, value: element.name });
                });
            },
            error => {
                let message = this.errorHandler.handleError(error);
                this.messagesService.addErrorMessage(message);
            }
        );
        this.products.push({ label: 'All Reactions', value: 'All Reactions' });

        this.masterDataService.getSalesItemTypeFilteredByLab(lab.lab._id).subscribe(
            results => {
                if (!results) {
                    return;
                }
                results.data.forEach(element => {
                    this.salesItemTypes.push({ label: element.sitKey, value: element.sitKey });
                });
            },
            error => {
                let message = this.errorHandler.handleError(error);
                this.messagesService.addErrorMessage(message);
            }
        );
        this.salesItemTypes.push({ label: 'All Reactions', value: 'All Reactions' });
    }

    /**
  * @function
  * @description: filters the reactionsets list with redo information
  */
    onRedoClick() {

        this.reactionSets = this.reactionSetsCached;

        let reactionSetsTemp: TreeNode[] = [];
        if (this.selectedRedoOption == 'repeat') {
            this.reactionSets.forEach(element => {
                this.filterReactionRedo(element, reactionSetsTemp, true);
            });
            this.reactionSets = [...reactionSetsTemp];
        }

        else if (this.selectedRedoOption == 'new') {
            this.reactionSets.forEach(element => {
                this.filterReactionRedo(element, reactionSetsTemp, false);
            });
            this.reactionSets = [...reactionSetsTemp];
        }

    }

    /**
   * @function
   * @description: recursively iterate through reactionset tree and create a filtered tree array
   */
    filterReactionRedo(childNode: TreeNode, parentArray: TreeNode[], isRedone: boolean) {

        if (childNode.children == null) {
            if (childNode.data.redone == isRedone)
                parentArray.push(childNode);
        }
        else {
            let newChild: TreeNode[] = [];
            childNode.children.forEach(node => {
                this.filterReactionRedo(node, newChild, isRedone);

            })
            if (newChild.length > 0) {
                parentArray.push({
                    data: childNode.data,
                    children: newChild
                });
            }
        }
    }

    /**
 * @function
 * @description: filters the reactionsets list with reorder information
 */
    onReorderClick() {

        this.reactionSets = this.reactionSetsCached;

        let reactionSetsTemp: TreeNode[] = [];
        if (this.selectedReusedOption == 'reused') {
            this.reactionSets.forEach(element => {
                this.filterReactionForReOrder(element, reactionSetsTemp, true);
            });
            this.reactionSets = [...reactionSetsTemp];
        }

        else if (this.selectedReusedOption == 'new') {
            this.reactionSets.forEach(element => {
                this.filterReactionForReOrder(element, reactionSetsTemp, false);
            });
            this.reactionSets = [...reactionSetsTemp];
        }

    }

    /**
    * @function
    * @description: recursively iterate through reactionset tree and create a filtered tree array
   */
    filterReactionForReOrder(childNode: TreeNode, parentArray: TreeNode[], isReused: boolean) {

        if (childNode.children == null) {
            if (childNode.data.containsReusedMaterial == isReused)
                parentArray.push(childNode);
        }
        else {
            let newChild: TreeNode[] = [];
            childNode.children.forEach(node => {
                this.filterReactionForReOrder(node, newChild, isReused);

            })
            if (newChild.length > 0) {
                parentArray.push({
                    data: childNode.data,
                    children: newChild
                });
            }
        }
    }
    /**
    * @function
    * @description: cache reactionset tree and reset radio buttons to "all" status
   */
    resetDefaults() {
        this.reactionSetsCached = [];
        this.reactionSetsCached = [...this.reactionSets];
        this.selectedRedoOption = "all";
        this.selectedReusedOption = "all";
    }

    getReactionsToCancel() {
        this.quadrantView.removeReactions();
    }

    removeReactionsFromPlate(event) {
        let rpRequest = new ReactionPlacementRequest();
        rpRequest.reactionPlateId = this.pendingPlateId;
        rpRequest.reactionSetIds = event;
        rpRequest.reactionPlateQuadrants = this.setQuadrant(this.quadrantId);
        if (rpRequest.reactionSetIds.length !== 0) {
            this.reactionSetService.removeReactionSetsFromPlate(rpRequest).subscribe(
                result => {
                    if (!result) {
                        this.messagesService.addErrorMessage({
                            severity: 'error', summary: 'NO PLATE DATA RECEIVED', detail: 'No plate data has been returned by backend'
                        });
                        return;
                    }
                    this.responseContainers = this.createEmptyContainers(result.data);
                    this.refreshPendingReactionPlates();
                    this.refreshProcessedReactionPlates();
                    this.messagesService.addSuccessMessage({
                        severity: 'success', summary: 'Removed Reactions', detail: 'Reactions are successfully removed from the reaction plate.'
                    });
                    this.blocked = false;
                },
                error => {
                    let message = this.errorHandler.handleError(error);
                    this.messagesService.addErrorMessage(message);
                    this.blocked = false;
                }
            );
        }
        else {
            this.messagesService.addErrorMessage({
                severity: 'warn', summary: 'No Reaction Selected', detail: 'Please select Reactions to be removed from Reaction plate.'
            });
        }

    }

    filterReactions() {
        this.loading = true;
        const lab = JSON.parse(localStorage.getItem('lab'));

        this.reactionSetService.fetchReactionSetsWithFilter(this.primerName, this.sampleContainer, this.selectedPriority, this.selectedSampleUsageType,
            this.selectedReactionOptionProtocol, this.selectedPrimerType, lab.lab._id).subscribe(
                results => {

                    if (!results) {
                        return;
                    }
                    if (results.data) {
                        //console.log("Reaction sets:", results.data);
                        this.storageResponse = results.data;
                        this.storageResponseCached = results.data;
                        this.reactionSets = [];
                        this.quadrents = [];
                        this.selectedNode = null;
                        this.dnaPlates = [];
                        this.storageResponse.forEach(plate => {

                            if (plate.materialType == "Sample") {
                                this.dnaPlates.push({ barcode: plate.conatinerBarcode, id: plate.conatinerId })
                                //console.log(this.dnaPlates);
                            }

                            let quadNodes: TreeNode[] = [];

                            if (plate.quadrantResponseList.length > 0) {

                                plate.quadrantResponseList.forEach(quadResponse => {

                                    let runLevelNodes: TreeNode[] = []
                                    if (quadResponse.levelItems.length > 0) {

                                        quadResponse.levelItems.forEach(levelResponse => {

                                            let reactionNodes: TreeNode[] = [];
                                            if (levelResponse.reactionSetResponseList.length > 0) {

                                                levelResponse.reactionSetResponseList.forEach(reaction => {
                                                    reactionNodes.push({
                                                        data: reaction
                                                    })
                                                })
                                            }
                                            if (reactionNodes.length > 0)
                                                runLevelNodes.push({
                                                    data: levelResponse,
                                                    children: reactionNodes
                                                })
                                        })
                                    }

                                    quadNodes.push({
                                        data: quadResponse,
                                        children: runLevelNodes
                                    })

                                })

                                this.reactionSets.push({
                                    data: plate,
                                    children: quadNodes
                                })
                            }


                            let runLevelNodes: TreeNode[] = []
                            if (plate.runLevelResponseList.length > 0) {

                                plate.runLevelResponseList.forEach(levelResponse => {

                                    let reactionNodes: TreeNode[] = []
                                    if (levelResponse.reactionSetResponseList.length > 0) {

                                        levelResponse.reactionSetResponseList.forEach(reaction => {
                                            reactionNodes.push({
                                                data: reaction
                                            })
                                        })
                                    }
                                    if (reactionNodes.length > 0)
                                        runLevelNodes.push({
                                            data: levelResponse,
                                            children: reactionNodes
                                        })

                                });

                                this.reactionSets.push({
                                    data: plate,
                                    children: runLevelNodes
                                })
                            }
                        })
                    }
                    this.loading = false
                    this.resetDefaults();
                },
                error => {
                    let message = this.errorHandler.handleError(error);
                    this.messagesService.addErrorMessage(message);
                    this.loading = false;
                }
            )


    }

    setPlateState(event) {
        this.plateState = event;
    }
    setPlateStateForEditPlate(event) {
        this.plateState = event;
    }
    plateStateIsReactionPlaced() {
        return this.plateState != null && this.plateState != undefined && this.plateState === ReactionPlateState.REACTIONS_PLACED.toString();
    }

    // clear filters applied to fetch reaction set
    clearFilter() {
        this.refreshData(true);
    }
}
